import { Pipe, PipeTransform } from '@angular/core';
import { ProductData } from '../../../../../../core/model/Product.model';

@Pipe({
  name: 'productOrderBy'
})
export class ProductOrderByPipe implements PipeTransform {

  transform(productData: ProductData[], args: string): any {
    if (!args || args.trim() == '') {
      return productData;
    }
    // console.log(productData);
    // console.log(args);
    switch (args) {
      case 'A':
        return Array.from(productData).sort((item1: any, item2: any) => {

          return this.orderByComparator(
            item1['PrecioVenta'],
            item2['PrecioVenta']
          );
        });

        break;
      case 'B':
        return Array.from(productData).sort((item1: any, item2: any) => {
          return this.orderByComparator(
            item2['PrecioVenta'],
            item1['PrecioVenta']
          );
        });

        break;
      case 'C':

        return Array.from(productData).sort((item1: any, item2: any) => {
          return this.orderByStringComparator(
            item1['ClaveProveedor'],
            item2['ClaveProveedor'], 1
          );
        });

        break;
      case 'D':

        return Array.from(productData).sort((item1: any, item2: any) => {
          return this.orderByStringComparator(
            item1['ClaveProveedor'],
            item2['ClaveProveedor'], 2
          );
        });

        break;
      case 'E':
        return Array.from(productData).sort((item1: any, item2: any) => {
          return this.orderByStringComparator(
            item1['Descripcion'],
            item2['Descripcion'], 1
          );
        });
        break;
      case 'F':
        return Array.from(productData).sort((item1: any, item2: any) => {
          return this.orderByStringComparator(
            item1['Descripcion'],
            item2['Descripcion'], 2
          );
        });
        break;
      case 'G':
        return Array.from(productData).sort((item1: any, item2: any) => {
          return this.orderByStringComparator(
            item1['ExistenciasSucursal'],
            item2['ExistenciasSucursal'], 1
          );
        });
        break;
      case 'H':
        return Array.from(productData).sort((item1: any, item2: any) => {
          return this.orderByStringComparator(
            item1['ExistenciasSucursal'],
            item2['ExistenciasSucursal'], 2
          );
        });
        break;
      case 'I':
        return Array.from(productData).sort((item1: any, item2: any) => {
          return this.orderByStringComparator(
            item1['ExistenciasCedis'],
            item2['ExistenciasCedis'], 1
          );
        });
        break;
      case 'J':
        return Array.from(productData).sort((item1: any, item2: any) => {
          return this.orderByStringComparator(
            item1['ExistenciasCedis'],
            item2['ExistenciasCedis'], 2
          );
        });
        break;
      case 'Checkout_Service_order':
        if (!productData) {
          return [];
        }

        return Array.from(productData).sort((item1: any, item2: any) => {
          const isCedis1 = item1['isCedis'] === true ? 1 : 0;
          const isCedis2 = item2['isCedis'] === true ? 1 : 0;
          return this.orderByComparator(isCedis2, isCedis1);
        });


        break;
    }
  }

  orderByComparator(a: any, b: any): number {

    if (
      isNaN(parseFloat(a)) || !isFinite(a) ||
      isNaN(parseFloat(b)) || !isFinite(b)
    ) {
      if (a.toLowerCase() < b.toLowerCase()) return -1;
      if (a.toLowerCase() > b.toLowerCase()) return 1;
    } else {
      if (parseFloat(a) < parseFloat(b)) return -1;
      if (parseFloat(a) > parseFloat(b)) return 1;
    }
    return 0;
  }

  orderByStringComparator(a: any, b: any, args: number): number {
    if (args === 1) {
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    } else {
      if (a > b) {
        return -1;
      } else if (a < b) {
        return 1;
      } else {
        return 0;
      }
    }
  }

}
